module.exports = __webpack_public_path__ + "img/1fce49e.png";